import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

export function AreaText({ area, unit, longUnit, autoConvert, removeUnit }) {
    const areaUnit =
        unit ||
        useSelector(
            state => (state.user && state.user.prefs && state.user.prefs.defaultAreaUnit) || 'ha'
        );

    function formatArea(areaUnit, area, longUnit, autoConvert) {
        switch (areaUnit) {
            case 'ha':
                return `${Math.max(area * 0.0001, 0.01).toLocaleString(undefined, {
                    maximumFractionDigits: 2
                })} ${!removeUnit ? (longUnit ? 'hectares' : 'ha') : ''}`;
            case 'ac':
                return `${Math.max(area * 0.000247105, 0.01).toLocaleString(undefined, {
                    maximumFractionDigits: 2
                })} ${!removeUnit ? (longUnit ? 'acres' : 'ac') : ''}`;
            case 'sqft':
                return `${Math.max(area * 10.7639, 0.01).toLocaleString(undefined, {
                    maximumFractionDigits: 2
                })} ${!removeUnit ? 'sqft' : ''}`;
            case 'm2':
                return area > 999999 && autoConvert
                    ? `${Math.max(area * 0.000001, 0.01).toLocaleString(undefined, {
                          maximumFractionDigits: 2
                      })} ${!removeUnit ? 'km²' : ''}`
                    : `${Math.max(area, 0.01).toLocaleString(undefined, {
                          maximumFractionDigits: 2
                      })} ${!removeUnit ? 'm²' : ''}`;
            case 'km2':
                return `${Math.max(area * 0.000001, 0.01).toLocaleString(undefined, {
                    maximumFractionDigits: 2
                })} ${!removeUnit ? 'km²' : ''}`;
            default:
                console.error('Invalid area unit', areaUnit);
                return `${Math.max(area * 0.0001, 0.01).toLocaleString(undefined, {
                    maximumFractionDigits: 2
                })} ${!removeUnit ? (longUnit ? 'hectares' : 'ha') : ''}`;
        }
    }

    return <span>{formatArea(areaUnit, area, longUnit, autoConvert)}</span>;
}

AreaText.propTypes = {
    area: PropTypes.number.isRequired,
    unit: PropTypes.oneOf(['ha', 'ac', 'sqft', 'm2', 'km2']),
    longUnit: PropTypes.bool,
    autoConvert: PropTypes.bool,
    removeUnit: PropTypes.bool
};

AreaText.defaultProps = {
    unit: undefined,
    longUnit: false,
    autoConvert: true,
    removeUnit: false
};
